"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ikeaSharedComponent = require("@ikea-aoa/ikea-shared-component");

var _Layout = _interopRequireDefault(require("./Layout.js"));

var _KeyboardEjs = _interopRequireDefault(require("./Keyboard.ejs.js"));

require("./Keyboard.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This component displays a virtual keyboard for the IKEA Kiosk.
 *
 * @example
 * <div>
 * <input type="number"/>
 * <ikea-component name="Keyboard"></ikea-component>
 * </div>
 * @example
 * <input type="number"/>
 * <Keyboard></Keyboard>
 */
var Keyboard = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(Keyboard, _AbstractComponent);

  var _super = _createSuper(Keyboard);

  /**
   * Class constructor.
   *
   * @param {Element} element The associated element.
   */
  function Keyboard(element) {
    var _this;

    _classCallCheck(this, Keyboard);

    _this = _super.call(this, element);
    _this.inputElements = [];
    _this.selectedInputElement = null;
    _this.selectedType = 'regular';
    _this.keys = null;
    _this.touchStart = _this.touchStart.bind(_assertThisInitialized(_this));
    _this.touchEnd = _this.touchEnd.bind(_assertThisInitialized(_this));
    _this.touchMove = _this.touchMove.bind(_assertThisInitialized(_this));
    _this._selectionListener = _this.handleSelect.bind(_assertThisInitialized(_this));
    _this._focusListener = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this._visible = false;
    _this._yTranslate = 0;
    _this.startPosition = {
      x: null,
      y: null
    };
    _this.endPosition = {
      x: null,
      y: null
    };
    _this._startTouchOnInput = false;
    document.body.addEventListener('mousedown', _this.touchStart);
    document.body.addEventListener('touchstart', _this.touchStart);
    document.body.addEventListener('touchmove', _this.touchMove);
    document.body.addEventListener('mouseup', _this.touchEnd);
    document.body.addEventListener('touchend', _this.touchEnd);
    return _this;
  }
  /**
   * Called when props will change.
   *
   * @override
   * @param {object} newProps New props.
   */


  _createClass(Keyboard, [{
    key: "propsWillChange",
    value: function propsWillChange(newProps) {
      var _this2 = this;

      if (newProps.disableSelection !== undefined) {
        this.inputElements.forEach(function (element) {
          return element.removeEventListener('select', _this2._selectionListener);
        });

        if (newProps.disableSelection) {
          this.inputElements.forEach(function (element) {
            return element.addEventListener('select', _this2._selectionListener);
          });
        }
      }
    }
    /**
     * Called when the component is loaded the first time.
     *
     * @override
     */

  }, {
    key: "load",
    value: function load() {
      _get(_getPrototypeOf(Keyboard.prototype), "load", this).call(this);

      var parentNode = this.element.parentNode;

      if (parentNode) {
        var elements = [].concat(_toConsumableArray(Array.from(parentNode.getElementsByTagName('input'))), _toConsumableArray(Array.from(parentNode.getElementsByTagName('textarea'))));

        var _iterator = _createForOfIteratorHelper(elements),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var element = _step.value;
            element.addEventListener('focus', this._focusListener);

            if (this.props.disableSelection) {
              element.addEventListener('select', this._selectionListener);
            }

            this.inputElements.push(element);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      this.selectedInputElement = this.inputElements[0];
    }
    /**
     * Handler for focus events.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      var myField = event.currentTarget;
      this.selectedInputElement = myField;
      var dataType = myField.getAttribute('data-keyboard-type');
      var type = dataType ? dataType : myField.type;
      this.selectedType = type === 'number' || type === 'email' ? type : 'regular';
      this.setProps({
        visible: true
      });
      this._visible = true;
      this.updatePosition();
      this.render();
    }
    /**
     * Handler for select evetns.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleSelect",
    value: function handleSelect(event) {
      var myField = event.currentTarget;
      var startPos = myField.selectionStart;
      myField.selectionStart = startPos;
      myField.selectionEnd = startPos;
    }
    /**
     * Gets the template.
     *
     * @override
     * @returns {Function} Template parse function.
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      var _this3 = this;

      this.keys = _Layout.default[this.props.layout.toUpperCase()][this.selectedType.toUpperCase()];
      var excludedKeys = this.props.exclude.replace(/\s+/gi, '').toUpperCase().split(',');

      var _iterator2 = _createForOfIteratorHelper(excludedKeys),
          _step2;

      try {
        var _loop = function _loop() {
          var excludedKey = _step2.value;
          _this3.keys = _this3.keys.map(function (array) {
            return array.filter(function (key) {
              return key.toUpperCase() !== excludedKey;
            });
          });
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return _KeyboardEjs.default;
    }
    /**
     * Updates position.
     */

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var keyboardHeight = this.element.querySelector('.Keyboard').offsetHeight;

      if (this.selectedInputElement) {
        var selectedInputRect = this.selectedInputElement.getBoundingClientRect();
        var currentBodyYTranslate = document.body.getBoundingClientRect().top;
        var inputHeightOutside = selectedInputRect.bottom - window.innerHeight;
        var selectedInputBottomOffset = window.innerHeight - selectedInputRect.bottom + currentBodyYTranslate;
        document.body.style.transition = this.props.inline ? null : 'transform 0.6s ease-in-out';

        if (selectedInputBottomOffset < keyboardHeight && this._visible) {
          var yTranslate = keyboardHeight - selectedInputBottomOffset + (inputHeightOutside > 0 ? -inputHeightOutside : 20);
          document.body.style.transform = 'translate3d(0, -' + yTranslate + 'px, 0)';
          this._yTranslate = yTranslate;
        } else {
          document.body.style.transition = this.props.inline ? null : 'transform 0.6s ease-in-out';
          document.body.style.transform = this.props.inline ? null : 'translate3d(0, 0, 0)';
          this._yTranslate = 0;
        }
      }

      if (!this.props.visible || this.props.inline) {
        document.body.style.transition = this.props.inline ? null : 'transform 0.6s ease-in-out';
        document.body.style.transform = this.props.inline ? null : 'translate3d(0, 0, 0)';
        this._yTranslate = 0;
      }
    }
    /**
     * Destroys the component.
     *
     * @override
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this4 = this;

      document.body.style.transition = null;
      document.body.style.transform = null;
      document.body.removeEventListener('mousedown', this.touchStart);
      document.body.removeEventListener('touchstart', this.touchStart);
      document.body.removeEventListener('touchmove', this.touchMove);
      document.body.removeEventListener('mouseup', this.touchEnd);
      document.body.removeEventListener('touchend', this.touchEnd);
      this.inputElements.forEach(function (element) {
        element.removeEventListener('focus', _this4._focusListener);
        element.removeEventListener('select', _this4._selectionListener);
      });
    }
    /**
     * Handles click on keyboard.
     *
     * @param {string} key Key pressed.
     */

  }, {
    key: "handleClick",
    value: function handleClick(key) {
      if (this.selectedInputElement !== null) {
        var keydownEvent = new Event('keydown');
        var keyupEvent = new Event('keyup');
        var changeEvent = new Event('change');
        var maxLength = this.selectedInputElement.getAttribute('maxlength');
        maxLength = maxLength === null ? -1 : parseInt(maxLength);

        if (key === 'backspace') {
          this.removeAtCursor(this.selectedInputElement);
        } else if (maxLength === -1 || this.selectedInputElement.value.length < maxLength) {
          this.insertAtCursor(this.selectedInputElement, key);
        }

        this.selectedInputElement.dispatchEvent(keydownEvent);
        this.selectedInputElement.dispatchEvent(keyupEvent);
        this.selectedInputElement.dispatchEvent(changeEvent);
      }
    }
    /**
     * Handles the insert of no characters.
     *
     * @param {Element} myField The element that will be affected of the change.
     * @param {string} myValue The key pressed.
     */

  }, {
    key: "insertAtCursor",
    value: function insertAtCursor(myField, myValue) {
      if (document.selection) {
        myField.focus();
        var sel = document.selection.createRange();
        sel.text = myValue;
      } else if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        myField.value = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length);
        myField.focus();
        myField.selectionStart = startPos + myValue.length;
        myField.selectionEnd = startPos + myValue.length;
      } else {
        myField.value += myValue;
      }
    }
    /**
     * Handles the insert of no characters.
     *
     * @param {Element} myField The element that will be affected of the change.
     */

  }, {
    key: "removeAtCursor",
    value: function removeAtCursor(myField) {
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        var remove = startPos === endPos ? 1 : 0;
        myField.value = myField.value.substring(0, startPos - remove) + myField.value.substring(endPos, myField.value.length);
        myField.focus();
        myField.selectionStart = startPos - remove;
        myField.selectionEnd = startPos - remove;
      } else {
        myField.value = myField.value.substring(0, myField.value.length - 1);
      }
    }
    /**
     * Handles global touch start on site.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "touchStart",
    value: function touchStart(event) {
      if (this.props.visible && !this.props.inline && !this.element.contains(event.target)) {
        var _iterator3 = _createForOfIteratorHelper(this.inputElements),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var element = _step3.value;

            if (element === event.target) {
              this._startTouchOnInput = true;
              return;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this._startTouchOnInput = false;

        if (event.type === 'touchstart') {
          this.startPosition = {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY
          };
        } else if (event.type === 'mousedown') {
          this.startPosition = {
            x: event.clientX,
            y: event.clientY
          };
        }
      } else {
        this._startTouchOnInput = true;
      }
    }
    /**
     * Handles global touch end on site.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "touchEnd",
    value: function touchEnd(event) {
      if (this.props.visible && !this.props.inline && !this.element.contains(event.target)) {
        if (this._startTouchOnInput === true) {
          return;
        }

        var dragDistance = 0;

        if (event.type === 'touchend') {
          dragDistance = Math.hypot(this.endPosition.x - this.startPosition.x, this.endPosition.y - this.startPosition.y);
        } else if (event.type === 'mousedown') {
          dragDistance = 0;
        }

        if (dragDistance < 10) {
          this.setProps({
            visible: false
          });
          this._visible = false;
          this.selectedInputElement.blur();
          this.updatePosition();
          this.render();
        }
      }
    }
    /**
     * Handles global touch move on site.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "touchMove",
    value: function touchMove(event) {
      if (this.props.visible && !this.props.inline && !this.element.contains(event.target)) {
        var _iterator4 = _createForOfIteratorHelper(this.inputElements),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var element = _step4.value;

            if (element === event.target) {
              return;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.endPosition = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY
        };
      }
    }
    /**
     * Returns the supported props.
     *
     * @summary
     * layout: Keyboard layout. Valid values: QWERTY, QWERTZ, AZERTY.
     * visible: Set to "true" to force the keyboard to be visible.
     * inline: "true" if the keyboard should be rendered inline.
     * exclude: A list of keys that should be excluded, separated by coma sign i.e. "0, 1, 2, A, B, C". The list is case insensitive.
     * disableSelection: When disabled, the keyboard will only use start position of the selection.
     * @returns {SupportedProp[]} Array of supported prop objects.
     */

  }], [{
    key: "supportedProps",
    get: function get() {
      return [new _ikeaSharedComponent.SupportedProp('layout', 'string', true, ['QWERTY', 'QWERTZ', 'AZERTY'], 'QWERTY'), new _ikeaSharedComponent.SupportedProp('exclude', 'string', false, null, ''), new _ikeaSharedComponent.SupportedProp('inline', 'boolean', false, null, false), new _ikeaSharedComponent.SupportedProp('visible', 'boolean', false, null, false), new _ikeaSharedComponent.SupportedProp('disableSelection', 'boolean', false, null, true)];
    }
    /**
     * Returns the component name.
     *
     * @override
     * @returns {string} Component name.
     */

  }, {
    key: "componentName",
    get: function get() {
      return 'Keyboard';
    }
  }]);

  return Keyboard;
}(_ikeaSharedComponent.AbstractComponent);

exports.default = Keyboard;